import { QueryClient } from '@tanstack/react-query';

/**
 * App-wide TanStack QueryClient singleton.
 *
 * Lives in its own module so it can be shared between the
 * `QueryClientProvider` in `AppWrapper` and any hook that needs the client
 * without going through React context. Those hooks pass this instance to
 * `useQuery` as the explicit `queryClient` argument instead of relying on
 * context.
 */
export const queryClient = new QueryClient({
	defaultOptions: {
		// Without this, every mount and tab focus refetches queries that set no staleTime.
		queries: { staleTime: 30_000 },
	},
});
